var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"template-height"},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",staticStyle:{"margin-bottom":"-70px"},attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":"/img/PayConnect.png","alt":"Pay-Connect","contain":"","max-height":"20"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }